import { useState, useEffect, useContext, useRef } from 'react';

import { cmnContext } from '../../../../common/CmnContext';
import { SaleListContext } from '../../SaleListContext';

export function SaleListDetailInstructor(props: any) {

  const sale = props.sale;

  const isPc = useContext(cmnContext).isPc;
  const instList = useContext(SaleListContext).instList;
  // 講師タップで検索
  const setSearchWord = useContext(SaleListContext).setSearchWord;
  const setDetailSale = useContext(SaleListContext).setDetailSale;

  const [inst, setInst] = useState(null);
  const [instName, setInstName] = useState<string>('');
  const defaultImg = '/images/page/lesson/live/noimage_female.png';
  const [instImg, setInstImg] = useState<string>(defaultImg);


  // 講師情報
  useEffect(() => {
    // 講師情報
    if (sale?.instructor_id && Array.isArray(instList)) {
      const instructor = instList.find(inst => inst.id === sale.instructor_id);
      if (instructor) {
        setInst(instructor);

        // 講師名
        setInstName(instructor.name);

        // 講師画像
        let instImgFile = (instructor.image_file);
        if(instImgFile) {
          // 設定済み
          setInstImg(`/images/instructor/${instImgFile}?202510`);
        } else if(instructor.gender == '1') {
          // 設定なし：男性
          setInstImg('/images/page/lesson/live/noimage_male.png');
        } else {
          // 設定なし：女性
          setInstImg(defaultImg);
        }
      }
    }
  }, [sale])


  // 講師タップで検索
  const onPressInst = () => {
    if(inst && instName) {
      setSearchWord(instName);
      setTimeout(() => {
        // 詳細モーダルを再生しない
        setDetailSale(null);
      }, 10)
    }
  }



  return (
    <>
    {inst &&
      <>
        {/* 講師情報 */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-start',
            gap: '5px',
          }}
          onClick={onPressInst}
        >

          {/* 講師画像 */}
          {instImg &&
            <img
              src={instImg}
              onError={(e) => {
                const target = e.currentTarget;
                target.onerror = null; // 無限ループ防止
                target.src = defaultImg;
              }}
              style={{
                width: isPc? '6%' : '15%',
                aspectRatio: '1 / 1',
                borderRadius: '50%',
                objectFit: 'cover',
              }}
            />
          }

          {/* 講師名 */}
          {instName &&
            <p style={{margin: 0,}}>【動画出演の講師】{instName}</p>
          }

        </div>
      </>
    }
    </>
  );
}